import { toItem } from '../mappers/item';
export function parseItems(res) {
  const cursor = res.data.next_offset;
  res.data.results = res.data.results || [];
  res.data.results = res.data.results.filter(item => !item.folderid);
  res.data = res.data.results.map(toItem);
  res.paging = {
    cursor: cursor || null,
    size: null
  };
  return res;
}